import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getMyCafeDailyWorkingHoursLoading: false,
  getMyCafeDailyWorkingHoursError: false,
  getMyCafeDailyWorkingHoursFailed: false,
  getMyCafeDailyWorkingHoursMessage: '',
  myCafeDailyWorkingHours: [],

  getMyRseeDailyWorkingHoursLoading: false,
  getMyRseeDailyWorkingHoursError: false,
  getMyRseeDailyWorkingHoursFailed: false,
  getMyRseeDailyWorkingHoursMessage: '',
  myRseeDailyWorkingHours: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_MY_CAFE_DAILY_WORKING_HOURS_LOADING: {
      return {
        ...state,
        getMyCafeDailyWorkingHoursLoading: true,
        getMyCafeDailyWorkingHoursFailed: false,
        getMyCafeDailyWorkingHoursError: false,
        getMyCafeDailyWorkingHoursMessage: ''
      };
    }
    case actionTypes.GET_MY_CAFE_DAILY_WORKING_HOURS_SUCCESS: {
      return {
        ...state,
        getMyCafeDailyWorkingHoursLoading: false,
        getMyCafeDailyWorkingHoursFailed: false,
        getMyCafeDailyWorkingHoursError: false,
        getMyCafeDailyWorkingHoursMessage: '',
        myCafeDailyWorkingHours: action.payload
      };
    }
    case actionTypes.GET_MY_CAFE_DAILY_WORKING_HOURS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getMyCafeDailyWorkingHoursLoading: false,
        getMyCafeDailyWorkingHoursFailed: true,
        getMyCafeDailyWorkingHoursError: false,
        getMyCafeDailyWorkingHoursMessage: message
      };
    }
    case actionTypes.GET_MY_CAFE_DAILY_WORKING_HOURS_REJECT: {
      return {
        ...state,
        getMyCafeDailyWorkingHoursLoading: false,
        getMyCafeDailyWorkingHoursFailed: false,
        getMyCafeDailyWorkingHoursError: true,
        getMyCafeDailyWorkingHoursMessage: ''
      };
    }


    case actionTypes.GET_MY_RSEE_DAILY_WORKING_HOURS_LOADING: {
      return {
        ...state,
        getMyRseeDailyWorkingHoursLoading: true,
        getMyRseeDailyWorkingHoursFailed: false,
        getMyRseeDailyWorkingHoursError: false,
        getMyRseeDailyWorkingHoursMessage: ''
      };
    }
    case actionTypes.GET_MY_RSEE_DAILY_WORKING_HOURS_SUCCESS: {
      return {
        ...state,
        getMyRseeDailyWorkingHoursLoading: false,
        getMyRseeDailyWorkingHoursFailed: false,
        getMyRseeDailyWorkingHoursError: false,
        getMyRseeDailyWorkingHoursMessage: '',
        myRseeDailyWorkingHours: action.payload
      };
    }
    case actionTypes.GET_MY_RSEE_DAILY_WORKING_HOURS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getMyRseeDailyWorkingHoursLoading: false,
        getMyRseeDailyWorkingHoursFailed: true,
        getMyRseeDailyWorkingHoursError: false,
        getMyRseeDailyWorkingHoursMessage: message
      };
    }
    case actionTypes.GET_MY_RSEE_DAILY_WORKING_HOURS_REJECT: {
      return {
        ...state,
        getMyRseeDailyWorkingHoursLoading: false,
        getMyRseeDailyWorkingHoursFailed: false,
        getMyRseeDailyWorkingHoursError: true,
        getMyRseeDailyWorkingHoursMessage: ''
      };
    }
    default: {
      return state;
    }
  }
};
